import React from "react";
import styled from "styled-components"

const Glassmorphism = styled.div`
    padding: 20px
    /* From https://css.glass */
    background: rgba(255, 255, 255, 1);
    border-radius: 20px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(3px);
    -webkit-backdrop-filter: blur(3px);
    border: 1px solid rgba(255, 255, 255, 0.3);
`
export default Glassmorphism


// WEBPACK FOOTER //
// ./src/views/Auth/components/Glassmorphism/index.jsx